module.exports = __webpack_public_path__ + "img/soccer-field-lines.6e3816ba.png";